module.exports = __webpack_public_path__ + "img/nr.fee637a9.png";